import { ApiCoursesCart } from 'ApiRest/Api/Courses/Cart'
import { ApiCoursesCartCheckout } from 'ApiRest/Api/Courses/Cart/Checkout'
import { ApiCoursesCartConsumer } from 'ApiRest/Api/Courses/Cart/Consumer'
import { ApiCoursesCartProductsCount } from 'ApiRest/Api/Courses/Cart/ProductsCount'
import { ApiCoursesPurchaseGenerateInvoices } from 'ApiRest/Api/Courses/Purchase/GenerateInvoices'
import { pick } from 'lodash'

// TODO: Закомментировано, на время отсутствия нового счетчика для курсов
// import { eventBus } from '@/pubsub/bus'

// const globalMessageOnProductRemoved = function ({ product }) {
//  eventBus.$emit('frontend.showcase.product.productRemoved', {
//    product,
//  })
// }

export default {
  async fetchProductsCount({ commit }) {
    const { data } = await ApiCoursesCartProductsCount.get()

    commit('setProductsCount', data)
  },

  async fetchProducts({ commit }) {
    const { data } = await ApiCoursesCart.get()

    commit('setProducts', data)
  },

  addProduct({ rootState }) {
    const { user, offer } = rootState.courses.common.product

    return ApiCoursesCart.post({
      offer: {
        id: offer.id,
      },
      consumer: {
        id: user.id,
      },
    })
  },

  async removeProduct(context, product) {
    // eslint-disable-next-line no-useless-catch
    try {
      await ApiCoursesCart.delete({
        offer: {
          id: product.offer.id,
        },
        consumer: {
          id: product.consumer.id,
        },
      })
      // TODO: Закомментировано, на время отсутствия нового счетчика для курсов
      // globalMessageOnProductRemoved({
      //  product,
      // })
    } catch (error) {
      throw error
    }
  },

  async checkout({ getters, commit }, withMaternityCapital) {
    const { data } = await ApiCoursesCartCheckout.post({
      items: getters.checkedProducts.map((product) => ({
        offer: {
          id: product.offer.id,
        },
        consumer: {
          id: product.consumer.id,
        },
      })),
      withMaternityCapital,
    })

    commit('setPurchase', data)
  },

  async addProductByLink(context, offerId) {
    await ApiCoursesCart.post({
      offer: {
        id: offerId,
      },
    })
  },

  async createInvoice({ state, commit }) {
    const { data } = await ApiCoursesPurchaseGenerateInvoices.put(
      state.purchase.id,
    )

    commit('setInvoices', data)
  },

  async updateConsumer({ state, commit }, payload) {
    const index = state.products.findIndex(
      (product) => product.id === payload.id,
    )

    const productStateFields = pick(state.products[index], [
      'isAcquiring',
      'isChecked',
      'hasError',
    ])

    const { data } = await ApiCoursesCartConsumer.patch(payload)

    commit('setProduct', {
      product: {
        ...productStateFields,
        ...data,
      },
      index,
    })
  },
}
